import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

import { aboutStylingGelContent as content } from 'assets/content/landingPages/stylingGel';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { CTA } from './CTA';

const DefineYourStyleContainer = styled('div')`
  width: 100vw;
  display: flex;
  flex-direction: column;
  ${legacyTheme.breakpoints.up('md')} {
    flex-direction: row-reverse;
  }
`;

const TextContainer = styled('div')`
  padding: ${legacyTheme.spacing.s48} ${legacyTheme.spacing.s36};
  display: flex;
  align-items: left;
  flex-direction: column;
  color: white;
  background-color: ${theme.colors.neutral[900]};

  ${legacyTheme.breakpoints.up('sm')} {
    padding: ${legacyTheme.spacing.s48} ${legacyTheme.spacing.s64};
  }
  ${legacyTheme.breakpoints.up('md')} {
    width: 50%;
    padding: ${legacyTheme.spacing.s72};
  }
  ${legacyTheme.breakpoints.up('lg')} {
    padding: ${legacyTheme.spacing.s144};
  }
`;

const StyledTextTitle = styled(Typography)`
  text-align: left;
  padding-bottom: ${legacyTheme.spacing.s24};
  ${legacyTheme.breakpoints.up('md')} {
    text-align: center;
  }
  ${legacyTheme.breakpoints.up('lg')} {
    text-align: left;
  }
`;

const StyledTextBody = styled(Typography)`
  text-align: left;

  ${legacyTheme.breakpoints.up('md')} {
    text-align: center;
  }
  ${legacyTheme.breakpoints.up('lg')} {
    flex-direction: row;
    padding-bottom: ${legacyTheme.spacing.s40};
    text-align: left;
  }
`;

const DefineYourStyleImage = styled('div')<{ img: string }>`
  width: 100%;
  height: 275px;
  /* Use a bg image to follow the left container height */
  background: ${({ img }) => `url(${img})`} no-repeat center / cover;
  ${legacyTheme.breakpoints.up('sm')} {
    height: 50vh;
  }
  ${legacyTheme.breakpoints.up('md')} {
    width: 50%;
    height: auto;
  }
`;

const StyledButton = styled(CTA)`
  width: 70%;
  ${legacyTheme.breakpoints.up('md')} {
    align-self: center;
  }
  ${legacyTheme.breakpoints.up('lg')} {
    align-self: flex-start;
  }
`;

type AboutStylingGelSectionProps = {
  variant: 'curl' | 'coily' | null;
};

export const AboutStylingGelSection = ({ variant = null }: AboutStylingGelSectionProps) => {
  const { headline, subHead, ctaText, image, curlImage, coilyImage } = content;
  const { isDesktop } = useResponsiveVariant();
  const activeImage = variant === 'coily' ? coilyImage : variant === 'curl' ? curlImage : image;

  return (
    <DefineYourStyleContainer>
      <DefineYourStyleImage img={activeImage.src.src} />
      <TextContainer>
        <StyledTextTitle variant="h1r-mono">{headline}</StyledTextTitle>
        <StyledTextBody>{subHead}</StyledTextBody>
        {isDesktop && (
          <StyledButton
            dataFrom="styling-gel-hero"
            dataTestId="styling-gel-lp-about-cta"
            variant="whiteFull"
          >
            {ctaText}
          </StyledButton>
        )}
      </TextContainer>
    </DefineYourStyleContainer>
  );
};
